/**
 * 游戏相关
 */
import * as ACTION from '../constants/types/gameTypes';
import * as $$BASE from './baseAction'
import * as $$USER from './userAction'
import { packageReq } from '../helpers/request';

// 获取热门游戏
export function getHotGame(platformId){

	var payload = packageReq('GET_HOTGAME', [platformId], null, 'GET', false);

	return {
		type: ACTION.GET_HOTGAME,
		payload,
		extend: platformId
	} 

}


/**
 * 获取游戏分类列表
 * @param  {[type]} platformId [平台ID]
 * @return {[type]}            [description]
 */
export function getGameCategories(){
	
	var payload = packageReq('GET_GAME_CATEGORIES', null, null, 'GET', false, 7);
	return {
		type: ACTION.GET_GAME_CATEGORIES,
		payload
	}

}

/**
 * 获取当前页的游戏列表
 * @param  {[type]}  platformId [平台ID]
 * @param  {[type]}  categoryId [分类ID]
 * @param  {[type]}  pageNo     [查询页]
 * @return {[type]}             [description]
 */
export function getCurrentGameList(platformId, categoryId, pageNo, pageSize){

	var payload = packageReq('GET_GAME_LIST', [pageSize, platformId, categoryId, pageNo], null, 'GET');
	return {
		type: ACTION.GET_GAME_LIST,
		payload,
		extend: platformId
	}

}

/**
 * 根据ORDER顺序获取banner信息
 * @param  {[type]} bannerId [1: 首页， 2：PT，3：BBIN, 4:H5，5：AG]
 * @return {[type]}         [description]
 */
export function getAds4Banner(bannerId, platformId){

	var payload = packageReq('BANNER_ALL', [bannerId], null, 'GET');

	return {
		type: ACTION.GET_BANNERS_FOR_GAME,
		payload,
		extend: platformId
	}

}

// 重置游戏密码
export function resetPlatformPassword(newPassword, platform){

	var payload = packageReq('MODIFY_PLATFORM_PASSWORD', [platform], {password: newPassword}, 'PUT', true);

	return {
		type: ACTION.MODIFY_PLATFORM_PASSWORD,
		payload,
		_success_: [
			{
				action: $$BASE.openAlert('重置游戏平台密码成功'),
				takeParam: false
			},
			{
				action: $$USER.getPlatformBalance(platform),
				takeParam: false
			}
		]
	}

}

// 获取平台开始游戏的地址（例如沙巴嵌套IFRAME的地址）
export function getPlatformPlayUrl(platform){

	var payload = packageReq('GET_PLATFORM_PLAYURL', [platform], null, 'GET');

	return {
		type: ACTION.GET_PLATFORM_PLAYURL,
		payload,
		extend: platform
	} 

}